<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" small color="success" class="mr-2" depressed>
        <v-icon left>add</v-icon>Thêm
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Thêm Cơ Sở Vật Chất</v-card-title>
      <v-card-text class="pt-4">
        <book-new-form ref="form" />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small depressed @click="cancel">Hủy</v-btn>
        <v-btn small depressed color="primary" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import BookNewForm from '@/components/basic/form/BookForm.vue'

export default {
  components: { BookNewForm },
  data: () => ({
    dialog: false
  }),
  methods: {
    ...mapActions('books', ['fetchBooks', 'createBook']),
    async save () {
      const data = this.$refs.form.getData()
      await this.createBook({
        data: {
          ...data,
          status: 'inventory',
          department: this.department.id
        }
      })
      this.dialog = false
      this.reset()
    },

    cancel () {
      this.reset()
      this.$emit('cancel')
      this.dialog = false
    },
    reset () {
      this.$refs.form.reset()
    }
  },
  created () {
    this.fetchBooks()
  },
  computed: {
    ...mapGetters('books', ['books']),
    ...mapGetters('app', ['department'])
  }
}
</script>
<style scoped>
</style>
